import React from "react";
import { Typography, Box } from "@mui/material";

export const Promotions = () => {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        Акции
      </Typography>
      <Typography variant="body1">
        Здесь будут отображаться акции и специальные предложения
      </Typography>
    </Box>
  );
};
